var cov_8vhr68n43 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Sticky/context.tsx",
      hash = "d3ac15d6ecc4876505262e5b7f235f59dd8742ca",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Sticky/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 38
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 8,
          column: 40
        }
      },
      "2": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "3": {
        start: {
          line: 10,
          column: 70
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "4": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 82
        }
      },
      "5": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 62
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 24
          },
          end: {
            line: 10,
            column: 25
          }
        },
        loc: {
          start: {
            line: 10,
            column: 70
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 70
          },
          end: {
            line: 10,
            column: 71
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 82
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 11,
            column: 21
          },
          end: {
            line: 11,
            column: 22
          }
        },
        loc: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 11,
            column: 62
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Sticky/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_8vhr68n43.s[0]++, createReactContext({})); // eslint-disable-next-line

export var Provider = (cov_8vhr68n43.s[1]++, context.Provider);
cov_8vhr68n43.s[2]++;
export var consumer = function consumer(Origin) {
  cov_8vhr68n43.f[0]++;
  cov_8vhr68n43.s[3]++;
  return function (props) {
    cov_8vhr68n43.f[1]++;
    cov_8vhr68n43.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 11,
          columnNumber: 3
        }
      }, function (value) {
        cov_8vhr68n43.f[2]++;
        cov_8vhr68n43.s[5]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, value, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 11,
              columnNumber: 31
            }
          }))
        );
      })
    );
  };
};